// @flow

import type { State } from './types';

type GlobalState = {
  activeLanguage: State,
};

export const getActiveLanguage = (state: GlobalState): State => state.activeLanguage;

export default null;
